import { axiosInstance } from './axiosInstance';

export const updateReview = data =>
    axiosInstance
        .patch(`/reviews`, data)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });

export const createReview = data =>
    axiosInstance
        .post(`/reviews`, data)
        .then(response => response.data)
        .catch(error => {
            throw error.response;
        });
